import { IEmailConta } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";

import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function CadastrarEmailContaService(requestBody: IEmailConta) {
    return Service(
        Axios.post(`/home/emailconta/cadastraremailconta`, requestBody)
    );
}

export async function DeletarEmailContaService(idEmailConta: number) {
    return Service(
        Axios.delete(
            `/home/emailconta/deletaremailconta?idEmailConta=${idEmailConta}`
        )
    );
}

export async function AtualizarEmailContaService(requestBody: IEmailConta) {
    return Service(
        Axios.put(`/home/emailconta/atualizaremailconta`, requestBody)
    );
}

export async function ListarEmailContaService(filtro: number) {
    return Service(
        Axios.get<Array<IEmailConta>>(
            `/home/emailconta/listaremailconta?filtro=${filtro}`
        )
    );
}

export async function GetEmailContaService(idEmailConta: number) {
    return Service(
        Axios.get<IEmailConta>(
            `/home/emailconta/getemailconta?idEmailConta=${idEmailConta}`
        )
    );
}

export async function ValidarEmailService(idEmailConta: number) {
    return Service(
        Axios.put(
            `/home/emailconta/validaremailconta?idEmailConta=${idEmailConta}`
        )
    );
}
